import { MFA_METHOD } from 'utils/constants';
import LoginNominationForm from 'pages/public/forms/LoginNominationForm';
import { useLoginNominate } from 'pages/public/hooks';

import { useLoginContext } from '../Login';

export default function LoginNomination() {
  const { setMethod } = useLoginContext();
  const { isLoading, mutate: loginNominate } = useLoginNominate();

  const handleSubmit = ({ method }: { method: MFA_METHOD }) => {
    loginNominate({ method });
    setMethod(method);
  };

  return (
    <>
      <div className="space-y-[10px] mt-[72px]">
        <h3 className="text-secondary text-[22px] leading-7 tracking-[0.04em] font-semibold">
          Let's make sure you're you
        </h3>
        <p className="text-sm font-normal">
          Choose how you want to verify your identity
        </p>
      </div>
      <LoginNominationForm disabled={isLoading} onSubmit={handleSubmit} />
    </>
  );
}
